import type { ReactNode } from 'react';

export const symbol_physical_therapy: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M483-275ZM598-75l-216-85H150q-12.75 0-21.37-8.63Q120-177.25 120-190v-130q0-83 58.5-141.5T320-520h429q38 0 64.5 26t26.5 64q0 31-19 55.5T773-342l-93 27v184q0 15.91-7.06 28.79Q665.89-89.33 654-81q-12.15 8.25-26.57 10.12Q613-69 598-75Zm-99.96-225H375q-14 0-23 9t-11 20q-2 11 3.68 22.45Q350.36-237.09 364-232l256 101v-169H498.04ZM180-220h113q-6-10-9.5-21.5T280-265q0-39 28-67t67-28h238l145-40q14-4 19-13t3-20q-2-11-10-19t-21-8H320q-58.33 0-99.17 40.83Q180-378.33 180-320v100Zm303-55ZM287-607q-47-47-47-113t47-113q47-47 113-47t113 47q47 47 47 113t-47 113q-47 47-113 47t-113-47Zm184-42q29-29 29-71t-29-71q-29-29-71-29t-71 29q-29 29-29 71t29 71q29 29 71 29t71-29Zm-71-71Z"
		/>
	</svg>
);
